import { generateKeys } from '../utils';
export const activityLogObjectTypes = generateKeys({
    bonusOffer: {
        value: 'bonus_offer',
        label: 'Bonus Offer',
        model: 'BonusOffer',
    },
    deposit: {
        value: 'deposit',
        label: 'Deposit',
        model: 'Deposit',
    },
    withdrawal: {
        value: 'withdrawal',
        label: 'Withdrawal',
        model: 'Withdrawal',
    },
    document: {
        value: 'document',
        label: 'Document',
        model: 'Document',
    },
    profileChange: {
        value: 'profile_change',
        label: 'Profile Change',
        model: 'ProfileChange',
    },
    appropTest: {
        value: 'approp_test',
        label: 'Approp Test',
        model: 'AppropTest',
    },
    user: {
        value: 'user',
        label: 'User',
        model: 'User',
    },
    account: {
        value: 'account',
        label: 'Account',
        model: 'Account',
    },
    cryptoTransaction: {
        value: 'crypto_transaction',
        label: 'Crypto Transaction',
        model: 'CryptoTransaction',
    },
    blacklist: {
        value: 'blacklist',
        label: 'Blacklist',
        model: 'Blacklist',
    },
    dueDiligence: {
        value: 'due_diligence',
        label: 'Due Diligence',
        model: 'DueDiligence',
    },
    suitabilityTest: {
        value: 'suitability_test',
        label: 'Suitability Test',
        model: 'SuitabilityTest',
    },
    ticket: {
        value: 'ticket',
        label: 'Ticket',
        model: 'Dummy',
    },
    survey: {
        value: 'survey',
        label: 'Survey',
        model: 'Survey',
    },
});
export const activityLogOrigins = generateKeys({
    client: {
        value: 'client',
        label: 'Client',
    },
    user: {
        value: 'user',
        label: 'User',
    },
    service: {
        value: 'service',
        label: 'Service',
    },
});
export const activityLogGraphqlTypes = generateKeys({
    genericLog: {
        name: 'GenericLog',
        value: 'genericLog',
    },
    withReasonLog: {
        name: 'withReasonLog',
        value: 'withReasonLog',
    },
    note: {
        name: 'Note',
        value: 'note',
    },
    tradingStatusLog: {
        name: 'TradingStatusLog',
        value: 'tradingStatusLog',
    },
    kycStatusLog: {
        name: 'KycStatusLog',
        value: 'kycStatusLog',
    },
    conversionStatusLog: {
        name: 'ConversionStatusLog',
        value: 'conversionStatusLog',
    },
    clientTypeLog: {
        name: 'ClientTypeLog',
        value: 'clientTypeLog',
    },
    agentLog: {
        name: 'AgentLog',
        value: 'agentLog',
    },
    complianceLog: {
        name: 'ComplianceLog',
        value: 'complianceLog',
    },
    diffLog: {
        name: 'DiffLog',
        value: 'diffLog',
    },
    transferFundsLog: {
        name: 'TransferFundsLog',
        value: 'transferFundsLog',
    },
    underMonitoringLog: {
        name: 'UnderMonitoringLog',
        value: 'underMonitoringLog',
    },
    allowNewAccountCreationLog: {
        name: 'AllowNewAccountCreationLog',
        value: 'allowNewAccountCreationLog',
    },
    accountCheckLog: {
        name: 'AccountCheckLog',
        value: 'accountCheckLog',
    },
    spoaLog: {
        name: 'SpoaLog',
        value: 'spoaLog',
    },
    docTranslationsLog: {
        name: 'DocumentTranslationsLog',
        value: 'docTranslationsLog',
    },
    userActionLog: {
        name: 'UserActionLog',
        value: 'userActionLog',
    },
    localDepositorLog: {
        name: 'LocalDepositorLog',
        value: 'localDepositorLog',
    },
    localDepositorClientLog: {
        name: 'LocalDepositorClientLog',
        value: 'localDepositorClientLog',
    },
});
export const activityLogSpoaAuthResult = generateKeys({
    granted: {
        value: 'granted',
        label: 'GRANTED',
        postposition: 'to',
        ibPostposition: 'from',
    },
    revoked: {
        value: 'revoked',
        label: 'REVOKED',
        postposition: 'from',
        ibPostposition: 'from',
    },
});
export const activityLogTypes = generateKeys({
    note: {
        value: 'note',
        label: 'Note',
        activityLogMessage: 'Created general note:',
        graphqlType: activityLogGraphqlTypes.note,
    },
    accountOpenNote: {
        value: 'account_open_note',
        label: 'Account Open Note',
        activityLogMessage: 'Created account open note:',
        graphqlType: activityLogGraphqlTypes.note,
    },
    salesClientNote: {
        value: 'sales_client_note',
        label: 'Sales client note',
        activityLogMessage: 'Created sales note:',
        graphqlType: activityLogGraphqlTypes.note,
    },
    affiliateClientNote: {
        value: 'affiliate_client_note',
        label: 'Affiliate client note',
        activityLogMessage: 'Created partner note:',
        graphqlType: activityLogGraphqlTypes.note,
    },
    createAdminBonusOffer: {
        value: 'create_admin_bonus_offer',
        label: 'Create Admin Bonus Offer',
        activityLogMessage: 'Created',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    copiedContactInfo: {
        value: 'copied_contact_info',
        label: 'Copied Contact Info',
        activityLogMessage: 'Copied Contact Info',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    requestedRevealPhone: {
        value: 'requested_reveal_phone',
        label: 'Requested reveal phone',
        activityLogMessage: 'Requested reveal phone',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    requestedRevealEmail: {
        value: 'requested_reveal_email',
        label: 'Requested reveal email',
        activityLogMessage: 'Requested reveal email',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleAllowTransfers: {
        value: 'toggle_allow_transfers',
        label: 'Toggle Allow Transfers',
        activityLogMessage: '${allowTransferFunds} transfer funds${account}',
        graphqlType: activityLogGraphqlTypes.transferFundsLog,
    },
    toggleUnderMonitoring: {
        value: 'toggle_under_monitoring',
        label: 'Toggle Under Monitoring',
        activityLogMessage: '${underMonitoring} under monitoring',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.underMonitoringLog,
    },
    toggleEffectiveFTD: {
        value: 'toggle_effective_ftd',
        label: 'Toggle Agent Effective FTD',
        activityLogMessage: 'Set Credited FTD to ${effectiveFTD}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleAllowNewAccounts: {
        value: 'toggle_allow_new_accounts',
        label: 'Toggle Allow New Accounts',
        activityLogMessage: '${allowNewAccounts} creation of new accounts',
        graphqlType: activityLogGraphqlTypes.allowNewAccountCreationLog,
    },
    approveAdminBonusOffer: {
        value: 'approve_admin_bonus_offer',
        label: 'Approve Admin Bonus Offer',
        activityLogMessage: 'Approved',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectAdminBonusOffer: {
        value: 'reject_admin_bonus_offer',
        label: 'Reject Admin Bonus Offer',
        activityLogMessage: 'Rejected',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.withReasonLog,
    },
    createDeposit: {
        value: 'create_deposit',
        label: 'Create Deposit',
        activityLogMessage: 'Created',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    releaseDeposit: {
        value: 'release_deposit',
        label: 'Release Deposit',
        activityLogMessage: 'Released',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectDeposit: {
        value: 'reject_deposit',
        label: 'Reject Deposit',
        activityLogMessage: 'Rejected',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.withReasonLog,
    },
    completeClientDeposit: {
        value: 'complete_client_deposit',
        label: 'Complete Deposit',
        activityLogMessage: 'Completed',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    attemptedToIncompleteClientDeposit: {
        value: 'attempted_to_incomplete_client_deposit',
        label: 'Attempted to Incomplete Deposit',
        activityLogMessage: 'Attempted to Incomplete',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    holdDeposit: {
        value: 'hold_deposit',
        label: 'Hold Deposit',
        activityLogMessage: 'Hold',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    notCompleteDeposit: {
        value: 'not_complete_deposit',
        label: 'Not Complete Deposit',
        activityLogMessage: 'Not completed',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    completeDeposit: {
        value: 'complete_deposit',
        label: 'Complete Deposit',
        activityLogMessage: 'Completed',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    failDeposit: {
        value: 'fail_deposit',
        label: 'Fail Deposit',
        activityLogMessage: 'Failed',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createWithdrawal: {
        value: 'create_withdrawal',
        label: 'Create Withdrawal',
        activityLogMessage: 'Created',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateWithdrawal: {
        value: 'update_withdrawal',
        label: 'Update Withdrawal',
        activityLogMessage: 'Updated',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    approveWithdrawal: {
        value: 'approve_withdrawal',
        label: 'Approve Withdrawal',
        activityLogMessage: 'Approved',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectWithdrawal: {
        value: 'reject_withdrawal',
        label: 'Reject Withdrawal',
        activityLogMessage: 'Rejected ',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.withReasonLog,
    },
    pendingWithdrawal: {
        value: 'pending_withdrawal',
        label: 'Pending Withdrawal',
        activityLogMessage: 'Pending ',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.withReasonLog,
    },
    processWithdrawal: {
        value: 'process_withdrawal',
        label: 'Process Withdrawal',
        activityLogMessage: 'Processed',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    holdWithdrawal: {
        value: 'hold_withdrawal',
        label: 'Placed withdrawal on Hold',
        activityLogMessage: 'Held',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createDocument: {
        value: 'create_document',
        label: 'Create Document',
        activityLogMessage: 'Created',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateDocument: {
        value: 'update_document',
        label: 'Update Document',
        activityLogMessage: 'Updated',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    approveDocument: {
        value: 'approve_document',
        label: 'Approve Document',
        activityLogMessage: 'Approved',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectDocument: {
        value: 'reject_document',
        label: 'Reject Document',
        activityLogMessage: 'Rejected',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.withReasonLog,
    },
    revertDocument: {
        value: 'revert_document',
        label: 'Revert Document',
        activityLogMessage: 'Reverted',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    resetClientPassword: {
        value: 'reset_client_password',
        label: 'Reset Client Password',
        activityLogMessage: 'Changed password',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateClientDetails: {
        value: 'update_client_details',
        label: 'Update Client Details',
        activityLogMessage: 'Updated details',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createLead: {
        value: 'create_lead',
        label: 'Create Lead',
        activityLogMessage: 'Created lead',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateAccountChecks: {
        value: 'update_account_checks',
        label: 'Update Account Checks',
        activityLogMessage: 'Updated account checks',
        graphqlType: activityLogGraphqlTypes.accountCheckLog,
    },
    ranAccountGBGCheck: {
        value: 'ran_account_gbg_checks',
        label: 'Ran Account GBG Checks',
        activityLogMessage: 'Ran account GBG checks',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    ranElectronicIdVerificationCheck: {
        value: 'ran_eidv_checks',
        label: 'Ran Account eIDV Checks',
        activityLogMessage: '[${source}] Ran account eIDV checks',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    approveProfileChange: {
        value: 'approve_profile_change',
        label: 'Approve Profile Change',
        activityLogMessage: 'Approved',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectProfileChange: {
        value: 'reject_profile_change',
        label: 'Reject Profile Change',
        activityLogMessage: 'Rejected',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.withReasonLog,
    },
    underReviewProfileChange: {
        value: 'under_review_profile_change',
        label: 'Under Review Profile Change',
        activityLogMessage: 'Under Review Profile Change',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.withReasonLog,
    },
    approveAppropTest: {
        value: 'approve_approp_test',
        label: 'Approve Appropriateness Test',
        activityLogMessage: 'Approved',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectAppropTest: {
        value: 'reject_approp_test',
        label: 'Reject Appropriateness Test',
        activityLogMessage: 'Rejected',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.withReasonLog,
    },
    setClientTradingStatus: {
        value: 'set_client_trading_status',
        label: 'Set Client Trading Status',
        activityLogMessage: 'Changed trading status to \'${tradingStatus}\'',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.tradingStatusLog,
    },
    setClientKycStatus: {
        value: 'set_client_kyc_status',
        label: 'Set Client KYC Status',
        activityLogMessage: 'Changed KYC status to \'${kycStatus}\'',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.kycStatusLog,
    },
    setClientConversionStatus: {
        value: 'set_client_conversion_status',
        label: 'Set Client Conversion Status',
        activityLogMessage: 'Changed conversion status to \'${conversionStatus}\'',
        graphqlType: activityLogGraphqlTypes.conversionStatusLog,
    },
    setClientType: {
        value: 'set_client_type',
        label: 'Set Client Type',
        activityLogMessage: 'Changed clients type to \'${clientType}\'',
        graphqlType: activityLogGraphqlTypes.clientTypeLog,
    },
    assignClientAgent: {
        value: 'assign_client_agent',
        label: 'Assign Client Agent',
        activityLogMessage: 'Assigned ${agentType} agent',
        graphqlType: activityLogGraphqlTypes.agentLog,
    },
    unassignClientAgent: {
        value: 'unassign_client_agent',
        label: 'Unassign Client Agent',
        activityLogMessage: 'Unassigned ${agentType} agent',
        graphqlType: activityLogGraphqlTypes.agentLog,
    },
    claimClientAgent: {
        value: 'claim_client_agent',
        label: 'Claim Client Agent',
        activityLogMessage: 'Claimed ${agentType} agent',
        graphqlType: activityLogGraphqlTypes.agentLog,
    },
    unclaimClientAgent: {
        value: 'unclaim_client_agent',
        label: 'Unclaim Client Agent',
        activityLogMessage: 'Unclaimed ${agentType} agent',
        graphqlType: activityLogGraphqlTypes.agentLog,
    },
    call: {
        value: 'call',
        label: 'Call',
        activityLogMessage: 'Called client',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateOwnDetails: {
        value: 'client_update_own_details',
        label: 'Client Update Own Details',
        activityLogMessage: 'Updated their own details',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateOwnEmail: {
        value: 'client_update_own_email',
        label: 'Client Update Own Email',
        activityLogMessage: 'Updated their own email',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    confirmOwnEmail: {
        value: 'client_confirm_own_email',
        label: 'Client Confirm Own Email',
        activityLogMessage: 'Confirmed their own email',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createOwnAppropTest: {
        value: 'client_create_own_approp_test',
        label: 'Client Create Own Appropriateness Test',
        activityLogMessage: 'Created their own appropriateness test',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    acceptOwnBonusOffer: {
        value: 'client_accept_own_bonus_offer',
        label: 'Client Accept Own Bonus Offer',
        activityLogMessage: 'Accepted bonus offer',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectOwnBonusOffer: {
        value: 'client_reject_own_bonus_offer',
        label: 'Client Reject Own Bonus Offer',
        activityLogMessage: 'Rejected bonus offer',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createWithdrawalRequest: {
        value: 'client_create_withdrawal_request',
        label: 'Client Create Withdrawal Request',
        activityLogMessage: 'Created withdrawal request',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    cancelWithdrawal: {
        value: 'client_cancel_withdrawal',
        label: 'Client Cancel Withdrawal',
        activityLogMessage: 'Canceled withdrawal',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateOwnPassword: {
        value: 'client_update_own_password',
        label: 'Client Updated Password',
        activityLogMessage: 'Changed their password',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createOwnDocument: {
        value: 'client_create_own_document',
        label: 'Client Create Document',
        activityLogMessage: 'Created own document',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    holdOwnDepositWithPCT: {
        value: 'client_hold_own_deposit_with_pct',
        label: 'Client Hold Deposit',
        activityLogMessage: 'Hold own deposit',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    notCompleteOwnDepositWithPCT: {
        value: 'client_not_complete_own_deposit_with_pct',
        label: 'Client Not Complete Deposit',
        activityLogMessage: 'Not completed own deposit',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    completeOwnDepositWithPCT: {
        value: 'client_complete_own_deposit_with_pct',
        label: 'Client Complete Deposit',
        activityLogMessage: 'Completed own deposit',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    failOwnDepositWithPCT: {
        value: 'client_fail_own_deposit_with_pct',
        label: 'Client Fail Deposit',
        activityLogMessage: 'Failed own deposit',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientHasDifferentIpCountry: {
        value: 'client_has_different_ip_country',
        label: 'Client Has Different IP Country',
        activityLogMessage: 'Has different IP country',
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    clientHasSamePhoneNumber: {
        value: 'client_has_same_phone_number',
        label: 'Client Has Same Phone Number',
        activityLogMessage: 'Has same phone number as ${otherUsersCount} other user(s):',
        graphqlType: activityLogGraphqlTypes.complianceLog,
        isNotification: true,
    },
    clientHasSameLastnameAndDob: {
        value: 'client_has_same_lastname_and_date_of_birth',
        label: 'Client Has Same Lastname And Date Of Birth',
        activityLogMessage: 'Has same last name and date of birth as ${otherUsersCount} other user(s):',
        graphqlType: activityLogGraphqlTypes.complianceLog,
        isNotification: true,
    },
    createdAccount: {
        value: 'client_created_account',
        label: 'Client Create Account',
        activityLogMessage: 'Create account',
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    userCreatedAccount: {
        value: 'user_created_account',
        label: 'User Create Account',
        activityLogMessage: 'Created account \'${accountLabel} - ${remoteId}\'',
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    updatedLeverage: {
        value: 'client_updated_leverage',
        label: 'Client Updated Account Leverage',
        activityLogMessage: 'Update Leverage',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    deletedAccount: {
        value: 'user_deleted_account',
        label: 'User Delete Account',
        activityLogMessage: 'Delete account \'${accountLabel} - ${remoteId}\'',
        graphqlType: activityLogGraphqlTypes.complianceLog,
        activityLogShowReason: true,
    },
    changedCompany: {
        value: 'client_changed_company',
        label: 'Client Changed Company',
        activityLogMessage: 'Changed Client Company',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    changedClientPotentialLevel: {
        value: 'changed_potential_level',
        label: 'Changed Potential Level',
        activityLogMessage: 'Changed Potential Level to ${potentialLevel}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    changedClientRating: {
        value: 'changed_rating',
        label: 'Changed rating',
        activityLogMessage: 'Changed rating to ${rating} with reason ${ratingReason}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleTopVip: {
        value: 'toggle_top_vip',
        label: 'Toggle Vip',
        activityLogMessage: '${topVip} Vip',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleContractor: {
        value: 'toggle_contractor',
        label: 'Toggle Contractor',
        activityLogMessage: '${isContractor} Contractor',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    requestedPhoneVerificationCode: {
        value: 'client_requested_phone_verification_code',
        label: 'Client Requested Phone Verification Code',
        activityLogMessage: 'Requested Phone Verification Code',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    verifiedPhone: {
        value: 'client_verified_phone',
        label: 'Client Verified Phone',
        activityLogMessage: 'Verified Phone',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createBonusDeposit: {
        value: 'create_bonus_deposit',
        label: 'Create Bonus Deposit',
        activityLogMessage: 'Created',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    approveBonusDeposit: {
        value: 'approve_bonus_deposit',
        label: 'Approve Bonus Deposit',
        activityLogMessage: 'Approved',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectBonusDeposit: {
        value: 'reject_bonus_deposit',
        label: 'Reject Bonus Deposit',
        activityLogMessage: 'Rejected',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.withReasonLog,
    },
    resetOwnForexPassword: {
        value: 'client_reset_own_forex_password',
        label: 'Client Reset Forex Password',
        activityLogMessage: 'Reset their forex account ${accountType} password',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    registered: {
        value: 'client_registered',
        label: 'Client Registered',
        activityLogMessage: 'Has accepted the Terms and Conditions and registered',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    binaryWalkthroughProvided: {
        value: 'binary_walkthrough_provided',
        label: 'Client Provided Binary Walkthrough',
        activityLogMessage: 'Provided Binary Walkthrough [Deprecated]',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    websiteWalkthroughProvided: {
        value: 'website_walkthrough_provided',
        label: 'Client Provided Dashboard Walkthrough',
        activityLogMessage: 'Provided Dashboard Walkthrough',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    mt4WalkthroughProvided: {
        value: 'mt4_walkthrough_provided',
        label: 'Client Provided Trading Walkthrough',
        activityLogMessage: 'Provided Trading Walkthrough',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    binaryWalkthroughDeleted: {
        value: 'binary_walkthrough_deleted',
        label: 'Binary Walkthrough Record Deleted',
        activityLogMessage: 'Deleted Binary Walkthrough [Deprecated]',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    websiteWalkthroughDeleted: {
        value: 'website_walkthrough_deleted',
        label: 'Dashboard Walkthrough Record Deleted',
        activityLogMessage: 'Deleted Dashboard Walkthrough',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    mt4WalkthroughDeleted: {
        value: 'mt4_walkthrough_deleted',
        label: 'Trading Walkthrough Record Deleted',
        activityLogMessage: 'Deleted Trading Walkthrough',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    changeSettings: {
        value: 'change_settings',
        label: 'Change System Settings',
        activityLogMessage: 'Changed settings',
        graphqlType: activityLogGraphqlTypes.diffLog,
    },
    alertResolved: {
        value: 'alert_resolved',
        label: 'Resolve Alert',
        activityLogMessage: 'Resolve Alert \'${alertType}\'',
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    affiliateUpdated: {
        value: 'affiliate_updated',
        label: 'Client Affiliate Updated',
        activityLogMessage: 'Updated Affiliate',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    affiliateAddedManually: {
        value: 'affiliate_added_manually',
        label: 'Client Affiliate Added Manually',
        activityLogMessage: 'Added Affiliate Manually',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    affiliateDeleted: {
        value: 'affiliate_deleted',
        label: 'Client Affiliate Deleted',
        activityLogMessage: 'Deleted Client Affiliate',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    kycDocumentsNotificationSent: {
        value: 'kyc_document_notification_sent',
        label: 'KYC Documents Notification Sent',
        activityLogMessage: 'Sent KYC Documents Notification',
        graphqlType: activityLogGraphqlTypes.genericLog,
        isNotification: true,
    },
    kycDocumentsNotificationReminderSent: {
        value: 'kyc_document_notification_reminder_sent',
        label: 'KYC Documents Notification Reminder Sent',
        activityLogMessage: 'Sent KYC Documents Notification Reminder',
        graphqlType: activityLogGraphqlTypes.genericLog,
        isNotification: true,
    },
    kycDocumentsNotificationFinalReminderSent: {
        value: 'kyc_document_notification_final_reminder_sent',
        label: 'KYC Documents Notification Final Reminder Sent',
        activityLogMessage: 'Sent KYC Documents Notification Final Reminder',
        graphqlType: activityLogGraphqlTypes.genericLog,
        isNotification: true,
    },
    setOptinMarketing: {
        value: 'client_set_optin_marketing',
        label: 'Changed optin marketing preference',
        activityLogMessage: 'Opted ${marketingInOut} marketing',
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    sendClientSecurityCode: {
        value: 'send_client_security_code',
        label: 'Sent Client Support Security Code',
        activityLogMessage: 'Support Security Code Sent',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    ranSkrillVerification: {
        value: 'ran_skrill_verification',
        label: 'Ran Skrill Verification',
        activityLogMessage: 'Ran Skrill verification',
        graphqlType: activityLogGraphqlTypes.accountCheckLog,
    },
    createCryptoTransaction: {
        value: 'client_created_crypto_transaction',
        label: 'Create Crypto Transaction',
        activityLogMessage: 'Created Crypto Transaction',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    completedOwnCryptoTransaction: {
        value: 'client_completed_own_crypto_transaction',
        label: 'Completed Own Crypto Transaction',
        activityLogMessage: 'Completed Crypto Transaction',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    cancelledOwnCryptoTransaction: {
        value: 'client_cancelled_own_crypto_transaction',
        label: 'Cancelled Own Crypto Transaction',
        activityLogMessage: 'Cancelled Crypto Transaction',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    completeClientCryptoTransaction: {
        value: 'complete_client_crypto_transaction',
        label: 'Complete Crypto Transaction',
        activityLogMessage: 'Completed',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    spoaAuthorization: {
        value: 'spoa_authorization',
        label: 'Grant or Revoke SPOA authorization',
        activityLogMessage: 'SPOA authorization was ${spoaAuthorization}',
        graphqlType: activityLogGraphqlTypes.spoaLog,
    },
    ibSpoaAuthorization: {
        value: 'ib_spoa_authorization',
        label: 'Granted or Revoked from IB the SPOA authorization',
        activityLogMessage: 'SPOA authorization has been ${spoaAuthorization}',
        graphqlType: activityLogGraphqlTypes.spoaLog,
    },
    toggleCanGrantSpoa: {
        value: 'toggle_can_grant_spoa',
        label: 'Can Grant SPOA toggle',
        activityLogMessage: '${canGrantSpoa} can grant SPOA',
        graphqlType: activityLogGraphqlTypes.spoaLog,
    },
    revokeSpoaForPartner: {
        value: 'revoke_spoa_for_partner',
        label: 'Revoke SPOA for IB partner',
        activityLogMessage: 'SPOA revoked by',
        graphqlType: activityLogGraphqlTypes.spoaLog,
    },
    revokeSpoaForClient: {
        value: 'revoke_spoa_for_client',
        label: 'Revoke SPOA for clients',
        activityLogMessage: 'SPOA revoked by',
        graphqlType: activityLogGraphqlTypes.spoaLog,
    },
    toggleCanIbTransfer: {
        value: 'toggle_can_ib_transfer',
        label: 'Can IB Transfer toggle',
        activityLogMessage: '${canIbTransfer} IB Transfer',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleHasHotAssets: {
        value: 'toggle_has_hot_assets',
        label: 'Has Hot Assets',
        activityLogMessage: '${hasHotAssets} Hot Assets',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleHasTelegram: {
        value: 'toggle_has_telegram',
        label: 'Has Telegram',
        activityLogMessage: '${hasTelegram} Telegram',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    removeDocument: {
        value: 'remove_document',
        label: 'Remove Document',
        activityLogMessage: 'Removed  Document',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    removeOwnDocument: {
        value: 'remove_own_document',
        label: 'Remove Own Document',
        activityLogMessage: 'Document ${documentId} canceled by the client',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    sendInvitation: {
        value: 'send_invitation',
        label: 'Send Invitation',
        activityLogMessage: 'Invitation Sent',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    setOptInSms: {
        value: 'client_set_opt_in_sms',
        label: 'Changed opt in SMS preference',
        activityLogMessage: 'Opted ${smsInOut} SMS',
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    updateEconomicProfile: {
        value: 'update_economic_profile',
        label: 'Update Client Economic Profile',
        activityLogMessage: 'Updated client economic profile',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    blacklist: {
        value: 'blacklist',
        label: 'User created, modified, or deleted a blacklist',
        activityLogMessage: 'User created, modified, or deleted a blacklist',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    requestTranslation: {
        value: 'request_translation',
        label: 'Request Translation',
        activityLogMessage: 'Requested client document translation from ${translator}',
        graphqlType: activityLogGraphqlTypes.docTranslationsLog,
    },
    submitTranslation: {
        value: 'submit_translation',
        label: 'Submit Translation',
        activityLogMessage: 'Submited client document translation',
        graphqlType: activityLogGraphqlTypes.docTranslationsLog,
    },
    editedAccount: {
        value: 'user_edited_account',
        label: 'User Edit Account',
        activityLogMessage: 'Edited account \'${accountLabel} - ${remoteId}\'',
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    toggleAutochartist: {
        value: 'toggle_autochartist',
        label: 'Toggle Autochartist',
        activityLogMessage: '${toggleAutochartist} Autochartist',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleBDXCallCompleted: {
        value: 'toggle_bdx_call_completed',
        label: 'Toggle BDX Call Completed',
        activityLogMessage: '${toggleBDXCallCompleted} BDX Call Completed',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    bdxWaiverAccepted: {
        value: 'bdx_waiver_accepted',
        label: 'Toggle BDX Waiver Accepted',
        activityLogMessage: '${bdxWaiverAccepted} BDX Waiver Accepted',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleManualWithdrawals: {
        value: 'toggle_manual_withdrawals',
        label: 'Toggle Manual Withdrawals',
        activityLogMessage: '${manualWithdrawals} Manual Withdrawals',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleManualDeposits: {
        value: 'toggle_manual_deposits',
        label: 'Toggle Manual Deposits',
        activityLogMessage: '${manualDeposits} Manual Deposits',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleIsPhoneVerified: {
        value: 'toggle_is_phone_verified',
        label: 'Toggle Phone Verified',
        activityLogMessage: 'Phone ${toggleIsPhoneVerified} Verified',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleEmailConfirmed: {
        value: 'toggle_email_confirmed',
        label: 'Toggle Email Confirmed',
        activityLogMessage: 'Email ${toggleEmailConfirmed} Confirmed',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    bdxInvestmentChoiceFinal: {
        value: 'bdx_investment_choice_final',
        label: 'Investment choice final',
        activityLogMessage: 'Update BDX Final Investment Choice: ${previousBDXInvestmentChoice} to ${bdxInvestmentChoiceFinal}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleAffiliateAutomatedCommissions: {
        value: 'toggle_affiliate_automated_commissions',
        label: 'Toggle Affiliate Automated Commissions',
        activityLogMessage: 'Affiliate automated commissions ${automaticAffiliateCommissions}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientCreatedSubscription: {
        value: 'client_created_subscription',
        label: 'Created Subscription',
        activityLogMessage: 'Added subscription to account \'${accountLabel} - ${remoteId}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientCancelledSubscription: {
        value: 'client_cancelled_subscription',
        label: 'Cancelled Subscription',
        activityLogMessage: 'Cancelled subscription for account \'${accountLabel} - ${remoteId}\'. Last date is ${lastActiveDate}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientReactivatedSubscription: {
        value: 'client_reactivated_subscription',
        label: 'Reactivated Subscription',
        activityLogMessage: 'Reactivated subscription for account \'${accountLabel} - ${remoteId}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientChangedSubscription: {
        value: 'client_changed_subscription',
        label: 'Changed Subscription',
        activityLogMessage: 'Changed subscription for account \'${accountLabel} - ${remoteId}\' to ${newPlan}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userChangedSubscription: {
        value: 'user_changed_subscription',
        label: 'Changed Subscription',
        activityLogMessage: 'Changed subscription for account \'${accountLabel} - ${remoteId}\' to ${newPlan}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientUpdatedSubscriptionBillingInfo: {
        value: 'client_updated_subscription_billing_info',
        label: 'Changed updated subscription billing info',
        activityLogMessage: 'Updated subscription billing info',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientCheckedAgainstSanctions: {
        value: 'client_checked_against_sanctions',
        label: 'Client was checked against sanctions',
        activityLogMessage: 'Client was checked against sanctions',
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    allClientsCheckedAgainstSanctions: {
        value: 'all_clients_checked_against_sanctions',
        label: 'All clients were checked against sanctions',
        activityLogMessage: 'All clients were checked against sanctions',
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    assigneeDocument: {
        value: 'assignee_document',
        label: 'Assign Document',
        activityLogMessage: 'Assigned to ${assignee}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleHideWDMethods: {
        value: 'toggle_hide_wd_methods',
        label: 'Toggle Show all Withdrawal Methods',
        activityLogMessage: '${hideWDMethods} Show all WD Methods',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientLowMarginWarning: {
        value: 'client_low_margin_warning',
        label: 'Client low margin warning',
        activityLogMessage: 'Client low margin warning notification on ${accountLabel} - ${remoteId}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientLoginSuccess: {
        value: 'client_login_success',
        label: 'Client Login Success',
        activityLogMessage: 'Client login successfully',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createOwnDueDiligence: {
        value: 'client_create_own_due_diligence',
        label: 'Client Create Own Due Diligence',
        activityLogMessage: 'Created their own due diligence',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createDueDiligence: {
        value: 'create_due_diligence',
        label: 'Create Due Diligence',
        activityLogMessage: 'Created due diligence',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateDueDiligence: {
        value: 'update_due_diligence',
        label: 'Update Due Diligence',
        activityLogMessage: 'Changed Due Diligence to \'${dueDiligenceStatus}\'',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    revertDueDiligence: {
        value: 'revert_due_diligence',
        label: 'Revert Due Diligence',
        activityLogMessage: 'Reverted Due Diligence to Under Review',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleDormantReactivation: {
        value: 'toggle_dormant_reactivation',
        label: 'Toggle Dormant Reactivation',
        activityLogMessage: '${dormantReactivation} Dormant Reactivation',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    addUser: {
        value: 'add_user',
        label: 'Add User in CRM',
        activityLogMessage: 'Added User ${fullName}',
        graphqlType: activityLogGraphqlTypes.userActionLog,
    },
    editUserInfo: {
        value: 'edit_user_info',
        label: 'Edit User Info',
        activityLogMessage: 'Edited User Info for ${fullName}',
        graphqlType: activityLogGraphqlTypes.userActionLog,
    },
    clientCancelledDeposit: {
        value: 'client_cancelled_deposit',
        label: 'Client Cancelled Deposit',
        activityLogMessage: 'Client cancelled deposit',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userCancelledDeposit: {
        value: 'user_cancelled_deposit',
        label: 'User Cancelled Deposit',
        activityLogMessage: 'User cancelled deposit',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientCreatedVPSSubscription: {
        value: 'client_created_vps_subscription',
        label: 'Created VPS Subscription',
        activityLogMessage: 'Added VPS subscription \'${vpsPlanName} - ${vpsType}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientChangedVPSSubscription: {
        value: 'client_changed_vps_subscription',
        label: 'Changed VPS Subscription',
        activityLogMessage: 'Changed VPS subscription to ${vpsPlanName}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userChangedVPSSubscription: {
        value: 'user_changed_vps_subscription',
        label: 'Changed VPS Subscription',
        activityLogMessage: 'Changed VPS subscription to ${vpsPlanName}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userCancelledVPSSubscription: {
        value: 'user_cancelled_vps_subscription',
        label: 'Cancelled VPS Subscription',
        activityLogMessage: 'Cancelled subscription \'${vpsPlanName} - ${vpsType}\'. Last date is ${lastActiveDate}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientCancelledVPSSubscription: {
        value: 'client_cancelled_vps_subscription',
        label: 'Cancelled VPS Subscription',
        activityLogMessage: 'Cancelled subscription \'${vpsPlanName} - ${vpsType}\'. Last date is ${lastActiveDate}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userTerminatedVPSSubscription: {
        value: 'user_terminated_vps_subscription',
        label: 'Terminated VPS Subscription',
        activityLogMessage: 'Terminated subscription \'${vpsPlanName} - ${vpsType}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientTerminatedVPSSubscription: {
        value: 'client_terminated_vps_subscription',
        label: 'Terminated VPS Subscription',
        activityLogMessage: 'Terminated subscription \'${vpsPlanName} - ${vpsType}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientUpdatedVPSSubscriptionBillingInfo: {
        value: 'client_updated_vps_subscription_billing_info',
        label: 'Changed updated VPS subscription billing info',
        activityLogMessage: 'Updated subscription billing info',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    revertDeposit: {
        value: 'revert_deposit',
        label: 'Revert Deposit',
        activityLogMessage: 'Reverted',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    revertWithdrawal: {
        value: 'revert_withdrawal',
        label: 'Revert Withdrawal',
        activityLogMessage: 'Reverted',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    autochartistEmails: {
        value: 'autochartist_emails',
        label: 'Changed Autochartist emails preference',
        activityLogMessage: '${toggleAutochartistEmails} Autochartist Market Report Emails',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userAutochartistPlugin: {
        value: 'user_autochartist_plugin',
        label: 'Changed Autochartist plugin preference',
        activityLogMessage: '${toggleAutochartistPlugin} Autochartist plugin',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userAutochartistCoelationEmail: {
        value: 'user_autochartist_coelation_email',
        label: 'Changed Autochartist Coelation Email preference',
        activityLogMessage: '${toggleAutochartistCoelationEmail} Coelation Email',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleIgnoreIbTermination: {
        value: 'toggle_ignore_ib_termination',
        label: 'Igmore IB Termination',
        activityLogMessage: '${ignoreIbTermination} IB Termination',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleisDirectIB: {
        value: 'toggle_is_direct_ib',
        label: 'Client Is Direct IB',
        activityLogMessage: 'Client ${isDirectIB} Direct IB',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleIsReferredBySales: {
        value: 'toggle_is_referred_by_sales',
        label: 'Client Is Referred by Sales',
        activityLogMessage: 'Client ${isReferredBySales} Referred by sales',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleHasOpenComplaint: {
        value: 'toggle_has_open_complaint',
        label: 'Client Has Open Complaint',
        activityLogMessage: 'Client complaint ${hasOpenComplaint}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userUpdatedLastEffectiveCall: {
        value: 'user_updated_last_effective_call',
        label: 'User Updated Last Effective Call',
        activityLogMessage: 'Updated Last Effective Call',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleCopyTrading: {
        value: 'toggle_copy_trading',
        label: 'Allow Copy Trading',
        activityLogMessage: 'Allow Copy Trading ${allowCopyTrading}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientRequestCopyTrading: {
        value: 'client_request_copy_trading',
        label: 'Client Request Copy Trading',
        activityLogMessage: 'Request to ${clientCopyTrading} Copy Trading - Account: ${remoteId} - Provider: ${providerRemoteId}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userUpdateCopyTrading: {
        value: 'user_update_copy_trading',
        label: 'User Updated Copy Trading',
        activityLogMessage: 'Copy Trading ${userCopyTrading} - Account: ${remoteId}  - Provider: ${providerRemoteId}',
        graphqlType: activityLogGraphqlTypes.genericLog,
        activityLogShowReason: true,
    },
    clientLinked: {
        value: 'client_linked',
        label: 'Client linked',
        activityLogMessage: 'Linked client with',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientUnlinked: {
        value: 'client_unlinked',
        label: 'Client unlinked',
        activityLogMessage: 'Unlinked client with',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientCompetition: {
        value: 'client_competition',
        label: 'Client Entered Competition',
        activityLogMessage: 'Client entered competition \'${competitionName}\' (ID: ${competitionId}) with account \'${remoteId}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientExitCompetition: {
        value: 'client_exit_competition',
        label: 'Client Exited Competition',
        activityLogMessage: 'Client exited competition \'${competitionName}\' (ID: ${competitionId}) with account \'${remoteId}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    registrationRejectedUsCitizen: {
        value: 'registration_rejected_us_citizen',
        label: 'Client registration rejected. Reason: US Citizen',
        activityLogMessage: 'Client registration rejected. Reason: US Citizen',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createPartnersAppendix: {
        value: 'create_partners_appendix',
        label: 'Create Partners Appendix',
        activityLogMessage: 'User created partners appendix \'${partnersTemplate}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatePartnersAppendix: {
        value: 'update_partners_appendix',
        label: 'Update Partners Appendix',
        activityLogMessage: 'User updated partners appendix \'${partnersTemplate}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    togglePreSurvey: {
        value: 'toggle_pre_survey',
        label: 'Pre Survey',
        activityLogMessage: '${hasPreSurvey} Pre Survey',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleSurvey: {
        value: 'toggle_survey',
        label: 'Survey',
        activityLogMessage: '${hasSurvey} Survey',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    refundDeposit: {
        value: 'refund_deposit',
        label: 'Refund Deposit',
        activityLogMessage: 'Refunded',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleHasPortfolioManagement: {
        value: 'has_portfolio_management',
        label: 'Client Has Portfolio Management Enabled',
        activityLogMessage: '${hasPortfolioManagement} Portfolio Management',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleHasRawAccount: {
        value: 'has_raw_account',
        label: 'Client Has Raw account',
        activityLogMessage: 'Client ${hasRawAccount} raw account',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleHasVipAccount: {
        value: 'has_vip_account',
        label: 'Client Has Vip account',
        activityLogMessage: 'Client ${hasVipAccount} vip account',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createOwnSuitabilityTest: {
        value: 'client_create_own_suitability_test',
        label: 'Client Create Own Suitability Test',
        activityLogMessage: 'Created their own suitability test',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleWithdrawalApprovals: {
        value: 'toggle_withdrawal_approvals',
        label: 'Toggle Withdrawal Approvals Permission',
        activityLogMessage: 'Client withdrawal approvals are ${hasDisabledWithdrawals} ',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateAccountName: {
        value: 'update_account_name',
        label: 'Account Name Updated',
        activityLogMessage: 'Updated account name of \'${accountLabel} - ${remoteId}\' from \'${oldAccountName}\' to \'${clientAccountName}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatePromotionalCountries: {
        value: 'update_promotional_countries',
        label: 'Client Promotional Countries Updated',
        activityLogMessage: 'Client Promotional Countries Updated',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    claimedReward: {
        value: 'client_claimed_reward',
        label: 'Client Claimed Reward',
        activityLogMessage: 'Claimed Reward',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    referralActivated: {
        value: 'client_referral_activated',
        label: 'Client Referral Activated',
        activityLogMessage: 'Referral Activated as ${referralType} - Reward Amount ${rewardAmount}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleProvideCopyTrading: {
        value: 'toggle_provide_copy_trading',
        label: 'Toggle Provide Copy Trading',
        activityLogMessage: '${provideCopyTrading} Provide Copy Trading for \'${accountLabel} - ${remoteId}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
        activityLogShowReason: true,
    },
    updatePerformanceFee: {
        value: 'update_performance_fee',
        label: 'Performance Fee Updated',
        activityLogMessage: 'Updated Performance Fee of \'${accountLabel} - ${remoteId}\' to ${performanceFee}%',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientBonusLowEquityWarning: {
        value: 'client_bonus_low_equity_warning',
        label: 'Low equity warning, bonus will be removed',
        activityLogMessage: 'Client was notified that equity is low and bonus could be removed',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientBonusAcknowledged: {
        value: 'client_bonus_acknowledged',
        label: 'Client Bonus Acknowledged',
        activityLogMessage: 'Client Acknowledged Bonus Terms',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userEditedFundingDocument: {
        value: 'user_edited_funding_document',
        label: 'User Edited Funding Document',
        activityLogMessage: 'Set Funding Document to ${statusAndNotes}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    markedPaymentMethodThirdPartyVerified: {
        value: 'marked_payment_method_third_party_verified',
        label: 'Marked Payment Method Third Party Verified',
        activityLogMessage: '${action} Payment Method ${details} Third Party Verified',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleAllowAccountManually: {
        value: 'toggle_allow_account_manually',
        label: 'Toggle Manually Account',
        activityLogMessage: '${allowManuallyAccount} \'${manuallyAccountType}\' account type to be opened by Client',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userClosedAllTrades: {
        value: 'user_closed_all_trades',
        label: 'Close all trades',
        activityLogMessage: 'User ordered closing all trades on account \'${accountLabel} - ${remoteId}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientLoginVerificationSent: {
        value: 'client_login_verification_sent',
        label: 'Client Login Verification Sent',
        activityLogMessage: 'Client login successfully and verification code sent',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientEnabledSwapFree: {
        value: 'client_enabled_swap_free',
        label: 'Client Enabled Swap Free ',
        activityLogMessage: 'Client Enabled Swap Free for \'${accountLabel} - ${remoteId}\'',
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    clientHasMoreThanThreeUnverifiedCards: {
        value: 'client_three_unverified_cards',
        label: 'Client three or more unverified cards',
        activityLogMessage: 'Client Has More Than Three Unverified Cards',
        graphqlType: activityLogGraphqlTypes.genericLog,
        isNotification: true,
    },
    clientThirdPartyDocsRequested: {
        value: 'client_third_party_docs_reguqested',
        label: '3rd party documents requested',
        activityLogMessage: 'Requested Third Party Documents From Client',
        graphqlType: activityLogGraphqlTypes.genericLog,
        isNotification: true,
    },
    clientSourceOfFundsRequested: {
        value: 'client_source_of_funds_requested',
        label: 'Source of funds requested',
        activityLogMessage: 'Requested Source Of Funds Documents From Client',
        graphqlType: activityLogGraphqlTypes.genericLog,
        isNotification: true,
    },
    ticketCreatedUnresolved: {
        value: 'ticket_created_unresolved',
        label: 'New Ticket Created',
        activityLogMessage: 'New Ticket Created',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    ticketResolved: {
        value: 'ticket_resolved',
        label: 'Ticket is Resovled',
        activityLogMessage: 'Ticket is Resovled',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    ticketCreated: {
        value: 'ticket_created',
        label: 'Ticket is Created',
        activityLogMessage: 'Ticket is Created',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    ticketEdited: {
        value: 'ticket_edited',
        label: 'Ticket is Edited',
        activityLogMessage: 'Ticket is Edited',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    requestedUpdatedDocuments: {
        value: 'requested_updated_documents',
        label: 'Client Requested updated documents',
        activityLogMessage: 'Requested updated documents - \'${docType}\' document is due to expire in 4 weeks time',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientManuallyVerified: {
        value: 'client_manually_verified',
        label: 'Client Manually Verified',
        activityLogMessage: 'Manually Verified - ${verificationType} Verification',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    phoneVerificationInvalidPhone: {
        value: 'phone_verification_invalid_phone',
        label: 'Phone verification failed, invalid phone',
        activityLogMessage: 'Phone verification failed, invalid phone',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleHideMasterStrategies: {
        value: 'toggle_hide_master_strategies',
        label: 'Hide Master Strategies',
        activityLogMessage: '${hideMasterStrategies} Master Strategies',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleTradeCompanion: {
        value: 'toggle_trade_companion',
        label: 'Toggle Trade Companion',
        activityLogMessage: '${toggleTradeCompanion} Trade Companion',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleShowMasterStrategies: {
        value: 'toggle_show_master_strategies',
        label: 'Show Master Strategies',
        activityLogMessage: '${showMasterStrategies} Master Strategies',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleIgnoreAutoMigration: {
        value: 'toggle_ignore_auto_migration',
        label: 'Ignore Auto Migration',
        activityLogMessage: '${ignoreAutoMigration} Auto Migration',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    signedDocument: {
        value: 'signed_document',
        label: 'Client signed document',
        activityLogMessage: 'Signed document ${documentId}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    togglePasswordProtectedStrategies: {
        value: 'toggle_password_protected_strategies',
        label: 'Password Protected Strategies',
        activityLogMessage: '${passwordProtectedStrategies} Password Protected Strategies',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    togglePasswordStrategy: {
        value: 'toggle_password_strategy',
        label: 'Password Strategy',
        activityLogMessage: '${addPasswordStrategy} Password for \'${accountLabel} - ${remoteId}\' Strategy',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleTradingCentral: {
        value: 'toggle_tradingcentral',
        label: 'Toggle Trading Central',
        activityLogMessage: '${tradingCentralEnabled} Trading Central',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    affiliateContractSent: {
        value: 'affiliate_contract_sent',
        label: 'Affiliate Contract Sent',
        activityLogMessage: 'Affiliate Contract Sent',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    resetPasswordSuccess: {
        value: 'client_reset_password_success',
        label: 'Client Reset Password Success',
        activityLogMessage: 'Reset password success',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    resetPasswordAttempt: {
        value: 'client_reset_password_attempt',
        label: 'Client Reset Password Attempt',
        activityLogMessage: 'Reset password attempt',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    partnerLoyaltyActivated: {
        value: 'partner_loyalty_activated',
        label: 'Partner Loyalty ',
        activityLogMessage: 'Partner Loyalty programme activated',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientRedeemedPrize: {
        value: 'client_redeemed_prize',
        label: 'Client redeemed prize',
        activityLogMessage: 'Success redeemed: ${prize}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientExpiredEligibilityToRedeemPrize: {
        value: 'client_expired_eligibility_to_redeem_prize',
        label: 'Client not eligible to redeem prize',
        activityLogMessage: 'Client not eligible to redeem ${prize} prize',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    departmentEmailTemplateSent: {
        value: 'department_email_template_sent',
        label: 'Email Template Sent',
        activityLogMessage: 'Email Template Sent \n Template: ${selectedTemplate}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    partnerCustomizationUpdated: {
        value: 'partner_customization_updated',
        label: 'Partner Customization Updated',
        activityLogMessage: 'Partner Customization Updated',
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    accountsCustomizationUpdated: {
        value: 'accounts_customization_updated',
        label: 'Accounts Customization Updated',
        activityLogMessage: 'Accoutns Customization Updated',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientUploadStrategyAvatar: {
        value: 'client_upload_strategy_avatar',
        label: 'Client upload strategy Avatar',
        activityLogMessage: 'Uploaded stategy avatar - Remote id: \'${remoteId}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateStrategyAvatar: {
        value: 'update_strategy_avatar',
        label: 'Update strategy Avatar',
        activityLogMessage: '\'${strategyAvatarStatus}\' strategy avatar - Remote id: \'${remoteId}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    freeRawOfferSent: {
        value: 'free_raw_offer_sent',
        label: 'Sent free raw offer',
        activityLogMessage: 'Sent free raw offer ${isReminder}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    madeInboundCall: {
        value: 'made_inbound_call',
        label: 'Made Inbound Call',
        activityLogMessage: 'Made Inbound Call',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientSubmittedCorporateForm: {
        value: 'client_submitted_corporate_form',
        label: 'Client Submitted Corporate Form',
        activityLogMessage: 'Submitted corporate form',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    setClientCorporateStatus: {
        value: 'set_client_corporate_status',
        label: 'Set Client Corporate Status',
        activityLogMessage: 'Changed corporate status to \'${corporateStatus}\'',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateCorporateDetails: {
        value: 'update_corporate_details',
        label: 'Update Corporate Details',
        activityLogMessage: 'Updated corporate details',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientAcceptedReferTerms: {
        value: 'client_accepted_refer_terms',
        label: 'Client Accepted Refer Terms',
        activityLogMessage: 'Client Accepted Refer Terms',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleMissingDocuments: {
        value: 'toggle_missing_documents',
        label: 'Toggle Missing Documents',
        activityLogMessage: 'Toggle missing ${missingDocument} document to ${toggleMissing}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userNegativeBalanceReset: {
        value: 'negative_balance_reset',
        label: 'Negative balance reset',
        activityLogMessage: 'System user reset negative balance for ${accountType} account ${accountId}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleIBInterested: {
        value: 'toggle_ib_interested',
        label: 'Toggle Interested To Become IB',
        activityLogMessage: 'Toggle Interested To Become IB',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleIsPhoneVerificationRequestDisabled: {
        value: 'toggle_is_phone_verification_request_disabled',
        label: 'Toggle Phone Verification',
        activityLogMessage: 'Phone Verification Request ${toggleIsPhoneVerificationRequestDisabled}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleIsLoginVerified: {
        value: 'toggle_is_login_verified',
        label: 'Toggle Login Verified',
        activityLogMessage: 'Login ${toggleIsLoginVerified} Verified',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    callRecordedVerified: {
        value: 'call_recorded_verified',
        label: 'Call Recorded Verification',
        activityLogMessage: 'Call Recorded/Intro verified',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    callRecordedUnchecked: {
        value: 'call_recorded_unchecked',
        label: 'Call Recorded Unchecked',
        activityLogMessage: 'Call Recorded/Intro unchecked',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleOptInPromotions: {
        value: 'toggle_opt_in_promotions',
        label: 'Toggle Opt In Promotions',
        activityLogMessage: 'Toggle optin promotions ${toggleOptInPromotions}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientOptinAcountsToPromotions: {
        value: 'client_optin_accounts_to_promotions',
        label: 'Toggle Opt In Promotions',
        activityLogMessage: 'Accounts added to promotions ${accountsAdded}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleEducationalVideosLevel: {
        value: 'toggle_educational_videos_level',
        label: 'Toggle Educational Videos Level',
        activityLogMessage: '${isChecked} ${level} educational videos',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleTradingVideos: {
        value: 'toggle_trading_videos',
        label: 'Toggle Trading Videos',
        activityLogMessage: '${isChecked} ${tradingVideoType} trading videos',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    migrationTermsAccepted: {
        value: 'migration_terms_accepted',
        label: 'Migration Terms Accepted',
        activityLogMessage: 'Client has accepted the ${entity} Migration Terms',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientAcknowledgedAffiliateTerms: {
        value: 'client_acknowledged_affiliate_terms',
        label: 'Client acknowledged affiliate terms',
        activityLogMessage: 'Acknowledged affiliate terms',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    migrationClientNoticeAccepted: {
        value: 'migration_client_notice_accepted',
        label: 'Migration client notice accepted',
        activityLogMessage: 'Client has accepted the migration client notice',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleIsEmailLoginVerified: {
        value: 'toggle_is_email_login_verified',
        label: 'Toggle Email Login Verified',
        activityLogMessage: 'Email Login ${toggleIsEmailLoginVerified} Verified',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleIsEmailLoginVerificationRequestDisabled: {
        value: 'toggle_is_email_login_verification_request_disabled',
        label: 'Toggle Email Login Verification',
        activityLogMessage: 'Email Login Verification Request ${toggleIsEmailLoginVerificationRequestDisabled}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientRequestedEmailLoginVerificationCode: {
        value: 'client_requested_email_verification_code',
        label: 'Client Requested Email Login Verification Code',
        activityLogMessage: 'Requested Email Login Verification Code',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    localDepositorRegistration: {
        value: 'local_depositor_registration',
        label: 'Payment Agent Registration',
        activityLogMessage: 'Client Registered as Payment Agent',
        graphqlType: activityLogGraphqlTypes.localDepositorLog,
    },
    localDepositorStatusChange: {
        value: 'local_depositor_status_change',
        label: 'Payment Agent Status Change',
        activityLogMessage: 'Payment Agent Status Change to \'${localDepositorStatus}\'',
        graphqlType: activityLogGraphqlTypes.localDepositorLog,
    },
    localDepositorTermination: {
        value: 'local_depositor_termination',
        label: 'Payment Agent Termination',
        activityLogMessage: 'Payment Agent Terminated',
        graphqlType: activityLogGraphqlTypes.localDepositorLog,
    },
    localDepositorSubscription: {
        value: 'local_depositor_subscription',
        label: 'Payment Agent Subscription',
        activityLogMessage: 'Client ${subscribedClientId} was subscribed to Payment Agent',
        graphqlType: activityLogGraphqlTypes.localDepositorLog,
    },
    localDepositorClientSubscription: {
        value: 'local_depositor_client_subscription',
        label: 'Payment Agent Client Subscription',
        activityLogMessage: 'Client was subscribed to Payment Agent ${localDepositorId}',
        graphqlType: activityLogGraphqlTypes.localDepositorClientLog,
    },
    localDepositorUnsubscribed: {
        value: 'local_depositor_unsubscribed',
        label: 'Payment Agent Unsubscribed',
        activityLogMessage: 'Client ${subscribedClientId} was unsubscribed from Payment Agent',
        graphqlType: activityLogGraphqlTypes.localDepositorLog,
    },
    localDepositorClientUnsubscribed: {
        value: 'local_depositor_client_unsubscribed',
        label: 'Payment Agent Client Unsubscribed',
        activityLogMessage: 'Client was unsubscribed from Payment Agent ${localDepositorId}',
        graphqlType: activityLogGraphqlTypes.localDepositorClientLog,
    },
    userUpdatedClientMaxDeposits: {
        value: 'user_updated_client_max',
        label: 'User updated client max deposits',
        activityLogMessage: 'Updated client max deposits from ${oldMaxDeposits} to ${newMaxDeposits}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    sentCustomerSatisfactionSurvey: {
        value: 'sent_customer_satisfaction_survey',
        label: 'Customer Satisfaction survey was sent to client',
        activityLogMessage: 'Customer Satisfaction survey sent',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    submittedCustomerSatisfactionSurvey: {
        value: 'submitted_customer_satisfaction_survey',
        label: 'Customer Satisfaction survey submitted by client',
        activityLogMessage: 'Customer Satisfaction survey submitted',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateTradingAccountPassword: {
        value: 'client_update_trading_account_password',
        label: 'Client Update Trading Account Password',
        activityLogMessage: 'Changed their trading account ${accountId} password',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientMovedToArchiveSchema: {
        value: 'client_moved_to_archive_schema',
        label: 'Client moved to archive schema',
        activityLogMessage: 'Client moved to archive schema',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    sentWhatsAppMessage: {
        value: 'sent_whatsapp_message',
        label: 'WhatsApp message was sent to client',
        activityLogMessage: 'WhatsApp message sent',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientProductionSupportMonitoring: {
        value: 'client_production_support_monitoring',
        label: 'Production Support Monitoring',
        activityLogMessage: 'Production Support Monitoring',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientAcknowledgedWalletOwnershipDeposit: {
        value: 'client_acknowledged_wallet_ownership_deposit',
        label: 'Acknowledged Wallet Ownership Deposit',
        activityLogMessage: 'Acknowledged wallet ownership for',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientAcknowledgedWalletOwnershipWithdrawal: {
        value: 'client_acknowledged_wallet_ownership_withdrawal',
        label: 'Acknowledged Wallet Ownership Withdrawal',
        activityLogMessage: 'Acknowledged wallet ownership for',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateDeposit: {
        value: 'update_deposit',
        label: 'Update deposit',
        activityLogMessage: 'Updated',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientBecomePartnerCallback: {
        value: 'client_become_partner_callback',
        label: 'Client has requested a priority service callback to become a Partner',
        activityLogMessage: 'Client has requested a priority service callback to become a Partner',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
});
